/**
 * Back to Top button — shows after scrolling 400px, scrolls to top on click.
 */

export function initBackToTop() {
	const btn = document.querySelector( '.back-to-top' );
	if ( ! btn ) return;

	const toggleVisibility = () => {
		if ( window.scrollY > 400 ) {
			btn.removeAttribute( 'hidden' );
		} else {
			btn.setAttribute( 'hidden', '' );
		}
	};

	window.addEventListener( 'scroll', toggleVisibility, { passive: true } );

	btn.addEventListener( 'click', () => {
		window.scrollTo( { top: 0, behavior: 'smooth' } );
	} );

	toggleVisibility();
}
